$('#pagination-num, #pagination-page').on('change', function () {
    $val = $(this).val();
    if ($val.length) {
        window.location.href = $val;
    };
});